export const setItem = (key, value) => {
  if (typeof window !== "undefined") {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(
        `Something unexpected happendes during setting item in storage: ${error}`
      );
    }
  }
};

export const getItem = (key, defaultValue) => {
  if (typeof window !== "undefined") {
    try {
      const storageValue = JSON.parse(window.localStorage.getItem(key));
      return typeof storageValue === "undefined" ? defaultValue : storageValue;
    } catch (error) {
      console.error(
        `Something unexpected happendes during getting item from storage: ${error}`
      );
      return undefined;
    }
  }
  return undefined;
};

export const hasItem = (key) => {
  if (typeof window !== "undefined") {
    try {
      return window.localStorage.getItem(key) !== null;
    } catch (error) {
      console.error(
        `Something unexpected happendes during checking item in storage: ${error}`
      );
      return false;
    }
  }
  return false;
};

export const removeItem = (key) => {
  if (typeof window !== "undefined") {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      console.error(
        `Something unexpected happendes during removing item from storage: ${error}`
      );
    }
  }
};

export const clearStorage = () => {
  if (typeof window !== "undefined") {
    try {
      window.localStorage.clear();
    } catch (error) {
      console.error(
        `Something unexpected happendes during clearing storage: ${error}`
      );
    }
  }
};

export default { getItem, setItem, removeItem, clearStorage, hasItem };
